import type { Insight } from "@tandemdiabetes/sugarmate-api-react-client"
import styles from "./Tile.module.scss"
import { TileChildren } from "./TileChildren"

interface Props {
  id: string;
  insight: Insight;
}

export function OverlayTile(props: Props) {
  return (
    <div
      className={styles.container}
      id={props.id}
    >
      <button className={styles.overlayTile}>
        <TileChildren {...props} />
      </button>
    </div>
  )
}
